import { render, staticRenderFns } from "./ParentingInfo.vue?vue&type=template&id=0421ac7f"
import script from "./ParentingInfo.vue?vue&type=script&lang=js"
export * from "./ParentingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports